export default {"src":"/_next/static/media/facebook.bc951c3f.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};